import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import 'normalize.css';
import './styles/global.css';
import {tntBlue} from './theme/tntColors';
import reducer from './services/redux/reducer';

// Styles for React-Grid-Layout
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

// Styles for react-codemirror
import 'codemirror/lib/codemirror.css';

// Load highcharts
import Highcharts from 'highcharts';
window.Highcharts = Highcharts;
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/solid-gauge')(Highcharts);
require('highcharts/modules/wordcloud')(Highcharts);

import App from './layout/App';

// Set global Highcharts options
Highcharts.setOptions({
  credits: {
    enabled: false,
  },
  chart: {
    style: {
      fontFamily: '"Lato", Helvetica, Arial, sans-serif',
    },
  },
  colors: [tntBlue],
});

// Redux
let store = createStore(reducer, applyMiddleware(thunk));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js